import React from 'react'
import './winter-footer.css';


const WinterFooter = () => (
	<div className="ws-footer">

		<div className="d-flex d-wrap justify-content-around">

			<h3 className="m-3">
				<a href="mailto:info@wintersense.com?Subject=Tell%20Me%20More" className="footer__link" target="_top">
					Contact us <i className="fa fa-envelope mx-1"></i>
				</a>
			</h3>


			<h3 className="m-3">
				<a href="https://twitter.com/wintersense" className="footer__link">
					Follow <i className="fa fa-twitter mx-1"></i>
				</a>
			</h3>

		</div>
    
  </div>  
)


export default WinterFooter;


// WEBPACK FOOTER //
// ./src/components/WinterFooter/index.js